<template>
  <div class="avatar">
    <img v-if="image" :src="image">
    <span v-else-if="letters && color" :style="`background-color: ${color};`">{{ letters }}</span>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    letters: String,
    color: String,
  }
}
</script>

<style lang="scss" scoped>

</style>
